import type { PdfAnnotation } from "./types";
import { normRectToAbsolute } from "../utils/rects";

type Props = {
  pageWidth: number;
  pageHeight: number;
  annotations: PdfAnnotation[];
  onOpen: (annotation: PdfAnnotation) => void;
};

const typeColors: Record<PdfAnnotation["type"], string> = {
  highlight: "bg-warning/30 hover:bg-warning/40",
  note: "bg-info/30 hover:bg-info/40",
  explain: "bg-premium/30 hover:bg-premium/40",
};

export function PdfAnnotationLayer({
  pageWidth,
  pageHeight,
  annotations,
  onOpen,
}: Props) {
  return (
    <div className="pointer-events-none absolute inset-0 z-20">
      {annotations.map((a) => (
        <div key={a.id} className="absolute inset-0">
          {a.rects.map((r, idx) => {
            const abs = normRectToAbsolute(r, pageWidth, pageHeight);

            return (
              <button
                key={idx}
                type="button"
                className={`pointer-events-auto absolute rounded-sm transition-colors ${typeColors[a.type]}`}
                style={{
                  left: abs.left,
                  top: abs.top,
                  width: abs.width,
                  height: abs.height,
                }}
                onClick={() => onOpen(a)}
                aria-label={`Open ${a.type} annotation`}
              />
            );
          })}
        </div>
      ))}
    </div>
  );
}
